<template>
    <a-modal
      title="用户反馈"
      :visible="visible"
      @cancel='handleCancel'
      destroyOnClose
      centered
    >
    <div class="content">
        <a-form-model ref="form" :model="form" :rules="phoneRules">
            <a-form-model-item label="具体问题" prop="content">
                <a-textarea
                    v-model="form.content"
                    placeholder="使用过程中遇到了什么问题？欢迎说说你的想法。"
                    :maxLength="400"
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                />
            </a-form-model-item>
            <a-form-model-item label="图片" prop="annexCol">
                <upload
                    v-model="form.annexCol"
                    :uploadFilesFn='caseUploadFilesCase' :downloadFileFn='caseDownloadFile'
                    :maxLength="6" :maxSize='5'
                    :limitType='limitType'
                ></upload>
                <div class="tips">最多6个附件，每个附件最大5MB。您还可以上传图片进行反馈。</div>
            </a-form-model-item>
            <a-form-model-item label="联系电话" prop="tel">
                <a-input v-model="form.tel" placeholder="请输入" :maxLength="11" />
            </a-form-model-item>
        </a-form-model>
    </div>

    <template slot="footer">
        <a-button key="back" @click="handleCancel" class="cancel_btn">取 消</a-button>
        <a-button key="submit" class="submit_btn" type="primary" :loading="loading" @click="handleOk">提 交</a-button>
    </template>
        
    </a-modal>
</template>

<script>
import _ from 'lodash';
import upload from './upload/upload.vue'
import { suggestSave,caseDownloadFile,caseUploadFilesCase } from '@/services/set'
import { mapState } from 'vuex';

const defaultForm = {
    content: '',
    annexCol: [],
    tel: '',
}

export default {
    components:{
        upload
    },
    computed: {
      ...mapState('user', ['userInfo']),
    },
    props:{
        visible:{
            type: Boolean,
            default: false
        }
    },
    watch:{
        visible(val){
            if(val){
                this.form = _.cloneDeep(defaultForm)
                this.form.tel = this.userInfo ? this.userInfo.phone : ''
            }
        }
    },
    data(){
        return {
            form: _.cloneDeep(defaultForm),
            loading: false,
            limitType:[
                "JPG",
                "JPEG",
                "PNG",
                "BMP",
                "GIF",
                "SVG",
            ],
            phoneRules:{
                content:[
                    {
                        required: true,
                        message: '必填项，请输入内容！',
                    }
                ],
                tel:[
                    {
                        required: true,
                        message: '必填项，请输入内容！',
                    },
                    {
                      pattern:/^1[0-9]{10}$/,
                      message: '联系电话格式错误。',
                    }
                ],
            }
        }
    },
    methods:{
        caseDownloadFile,caseUploadFilesCase,
        handleOk(){
            this.$refs.form.validate(async (valid) => {
                if(valid){
                    this.loading = true
                    let res = await suggestSave(this.form)
                    if(res.code == 200){
                        this.$message.success(res.message)
                        this.handleCancel()
                    }
                    this.loading = false
                }
            })
        },
        handleCancel(){
            this.$emit('update:visible',false)
        },
    }
}
</script>

<style lang="scss" scoped>
.content{
    padding: 30px 20px;
}
.tips{
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    line-height: 22px;
}
.submit_btn{
    font-size: 14px !important;
    height: 32px !important;
    border-radius: 6px !important;
    line-height: 30px !important;
    background: #1677FF !important;
}
.cancel_btn{
    font-size: 14px !important;
    height: 32px !important;
    border-radius: 6px !important;
    line-height: 30px !important;
    border: 1px solid rgba(0,0,0,0.15);
}

::v-deep .ant-form-item-label{
    font-weight: 400 !important;
    font-size: 14px !important;
    color: rgba(0,0,0,0.88) !important;
    line-height: 22px !important;
    margin-bottom: 10px !important;
}
::v-deep .ant-modal{
    width: 560px !important;
}
::v-deep .ant-modal-body{
    padding: 0 !important;
}
::v-deep .ant-modal-title{
    font-weight: 500;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
}
</style>